import type {LocaleV3} from '@smart/locale-service';
import {INTERRUPTION_END_PATHS} from '../constants';
import {getLanguageMappedPaths} from './get-language-mapped-paths';

export const isValidInterruptionEndPath = (path: string, locale: LocaleV3) =>
  getLanguageMappedPaths(INTERRUPTION_END_PATHS, locale).includes(path);
